/**
 * Maps a filter state object → URLSearchParams-compatible query string.
 * Skips "empty" values so the API receives only active filters.
 *
 * Rules:
 *  - 'All' string  → skipped
 *  - empty array   → skipped
 *  - null/undefined → skipped
 *  - arrays        → joined with comma (matches existing backend expectation)
 *  - everything else → stringified as-is
 */
export function buildQueryString(filters) {
  const parts = [];

  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined || value === 'All') return;

    if (Array.isArray(value)) {
      if (value.length === 0) return;
      value.forEach((item) => {
        parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
      });
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });

  return parts.join('&');
}

export function hasActiveFilters(filters) {
  return Object.values(filters).some((value) => {
    if (value === null || value === undefined) return false;
    if (value === 'All') return false;
    if (Array.isArray(value)) return value.length > 0;
    return true;
  });
}

export function buildDefaultFilters(filterConfig) {
  return filterConfig.reduce((acc, field) => {
    acc[field.key] = field.defaultValue ?? (
      field.type === 'multi_select' ? [] : 'All'
    );
    return acc;
  }, {});
}